import { Euler, Matrix4, Object3D, Quaternion, Vector3 } from 'three';
export class LayoutManagerV3 {
    constructor(sceneSpecification) {
        this.sceneSpecification = sceneSpecification;
    }
    buildLayout() {
        return computeLayout(this.sceneSpecification);
    }
}
LayoutManagerV3.emptyLayout = {
    notConnectedParts: [],
    containers: [],
};
export function computeLayout(spec) {
    const transformMap = new Map();
    if (spec.rootPartId === undefined) {
        return LayoutManagerV3.emptyLayout;
    }
    transformMap.set(spec.rootPartId, new Matrix4());
    const childrenMap = new Map();
    for (const conn of spec.connections) {
        const parentId = conn.parts[0].id;
        if (!childrenMap.has(parentId)) {
            childrenMap.set(parentId, []);
        }
        childrenMap.get(parentId).push(conn);
    }
    const visited = new Set();
    function traverse(parentId) {
        visited.add(parentId);
        const parentMatrix = transformMap.get(parentId);
        const connections = childrenMap.get(parentId) || [];
        for (const conn of connections) {
            const [parentPart, childPart] = conn.parts;
            const M_joint_parent = toMatrix(parentPart);
            const M_joint_child = toMatrix(childPart);
            const M_child = new Matrix4()
                .multiplyMatrices(parentMatrix, M_joint_parent)
                .multiply(new Matrix4().copy(M_joint_child).invert());
            transformMap.set(childPart.id, M_child);
            traverse(childPart.id);
        }
    }
    traverse(spec.rootPartId);
    const notConnectedParts = spec.parts.filter((part) => !visited.has(part.id));
    return {
        containers: Array.from(transformMap.entries()).map(([id, transform]) => {
            const part = spec.parts.find((it) => it.id === id);
            if (!part) {
                throw new Error(`Cannot find part ${id}`);
            }
            const position = new Vector3();
            const quaternion = new Quaternion();
            const scale = new Vector3();
            transform.decompose(position, quaternion, scale);
            return {
                id,
                transform,
                fileName: part.fileName,
            };
        }),
        notConnectedParts,
    };
}
function getRotation(id, joint) {
    if (joint.direction) {
        console.error(`Unsupported old version of joint points found! part "${id}"`);
        const y = new Vector3().copy(joint.rotation).normalize();
        const z = new Vector3().copy(joint.direction).normalize();
        const x = new Vector3().copy(y).cross(z);
        const rotationMatrix = new Matrix4().makeBasis(x, y, z);
        const euler = new Euler();
        euler.setFromRotationMatrix(rotationMatrix, 'XYZ');
        return euler;
    }
    else {
        const euler = new Euler();
        euler.set(joint.rotation.x, joint.rotation.y, joint.rotation.z);
        return euler;
    }
}
function toMatrix(part) {
    const joint = part.jointPoint;
    const obj = new Object3D();
    obj.position.set(joint.position.x, joint.position.y, joint.position.z);
    obj.rotation.copy(getRotation(part.id, joint));
    obj.updateMatrix();
    return obj.matrix.clone();
}
//# sourceMappingURL=LayoutManagerV3.js.map